export default "__VITE_ASSET__Blcl9O4W__"